(function () {
  function parseProducts(root) {
    var script = root.querySelector('[data-ssp-products]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function createImage(url, alt, loading) {
    var img = document.createElement('img');
    img.src = url;
    img.alt = alt || 'Deep Sleep Shower Steamers';
    img.loading = loading || 'lazy';
    return img;
  }

  function initAccordions(root) {
    var details = Array.prototype.slice.call(root.querySelectorAll('.ssp-accordions details'));
    details.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        details.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initProduct(root) {
    var products = parseProducts(root);
    var selectedPack = products['15'] ? '15' : Object.keys(products)[0];
    var active = 0;
    var thumbsWrap = root.querySelector('[data-ssp-thumbs]');
    var slidesWrap = root.querySelector('[data-ssp-slides]');
    var current = root.querySelector('[data-ssp-current]');
    var total = root.querySelector('[data-ssp-total]');
    var progress = root.querySelector('[data-ssp-progress]');
    var prev = root.querySelector('[data-ssp-gallery-prev]');
    var next = root.querySelector('[data-ssp-gallery-next]');
    var variantInput = root.querySelector('[data-ssp-variant]');
    var packRadios = Array.prototype.slice.call(root.querySelectorAll('[data-ssp-pack]'));
    var packCards = Array.prototype.slice.call(root.querySelectorAll('[data-ssp-pack-card]'));
    var form = root.querySelector('[data-ssp-form]');
    var addButton = root.querySelector('.ssp-add');

    function getImages() {
      return products[selectedPack] && products[selectedPack].images ? products[selectedPack].images : [];
    }

    function syncProgress() {
      var images = getImages();
      if (current) current.textContent = String(active + 1);
      if (total) total.textContent = String(images.length || 1);
      if (progress) progress.style.width = (((active + 1) / Math.max(1, images.length)) * 100) + '%';
    }

    function setActive(index, scroll) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ssp-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ssp-thumb]'));
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === active);
      });
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === active);
      });
      syncProgress();
      if (scroll && slides[active]) {
        slides[active].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    }

    function renderGallery() {
      var images = getImages();
      active = 0;
      if (!thumbsWrap || !slidesWrap || !images.length) return;

      thumbsWrap.textContent = '';
      slidesWrap.textContent = '';

      images.forEach(function (image, index) {
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'ssp-thumb' + (index === 0 ? ' is-active' : '');
        thumb.setAttribute('data-ssp-thumb', String(index));
        thumb.setAttribute('aria-label', 'View image ' + (index + 1));
        thumb.appendChild(createImage(image.thumb, image.alt, 'lazy'));
        thumb.addEventListener('click', function () {
          setActive(index, true);
        });
        thumbsWrap.appendChild(thumb);

        var slide = document.createElement('figure');
        slide.className = 'ssp-slide' + (index === 0 ? ' is-active' : '');
        slide.setAttribute('data-ssp-slide', String(index));
        slide.appendChild(createImage(image.full, image.alt, index === 0 ? 'eager' : 'lazy'));
        slidesWrap.appendChild(slide);
      });

      slidesWrap.scrollLeft = 0;
      syncProgress();
    }

    function syncProduct() {
      var product = products[selectedPack];
      if (!product) return;
      if (variantInput) variantInput.value = product.variantId;
      root.dataset.pack = selectedPack;
      packCards.forEach(function (card) {
        var input = card.querySelector('[data-ssp-pack]');
        var activeCard = input && input.value === selectedPack;
        card.classList.toggle('is-selected', activeCard);
        if (input) input.checked = activeCard;
      });
      renderGallery();
    }

    packRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectedPack = radio.value;
        syncProduct();
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        var images = getImages();
        if (!images.length) return;
        setActive((active - 1 + images.length) % images.length, false);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var images = getImages();
        if (!images.length) return;
        setActive((active + 1) % images.length, false);
      });
    }

    if (slidesWrap) {
      var ticking = false;
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      slidesWrap.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesWrap.scrollLeft;
        slidesWrap.classList.add('is-dragging');
        if (slidesWrap.setPointerCapture) slidesWrap.setPointerCapture(event.pointerId);
      });

      slidesWrap.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        slidesWrap.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        slidesWrap.classList.remove('is-dragging');
        if (slidesWrap.releasePointerCapture) {
          try {
            slidesWrap.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      slidesWrap.addEventListener('pointerup', endDrag);
      slidesWrap.addEventListener('pointercancel', endDrag);
      slidesWrap.addEventListener('pointerleave', endDrag);
      slidesWrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var firstSlide = root.querySelector('[data-ssp-slide]');
          if (!firstSlide) {
            ticking = false;
            return;
          }
          var width = firstSlide.getBoundingClientRect().width + 8;
          setActive(Math.round(slidesWrap.scrollLeft / width), false);
          ticking = false;
        });
      }, { passive: true });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        var product = products[selectedPack];
        if (!product || !product.variantId) return;
        event.preventDefault();

        if (window.SoliniaCartDrawer && typeof window.SoliniaCartDrawer.addJson === 'function') {
          window.SoliniaCartDrawer.addJson({ id: Number(product.variantId), quantity: 1 }, addButton).catch(function (error) {
            console.error(error);
          });
          return;
        }

        if (addButton) addButton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(product.variantId),
            quantity: 1,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function (parsedState) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && parsedState.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents(parsedState);
            } else {
              window.location.href = '/cart';
            }
          })
          .finally(function () {
            if (addButton) addButton.disabled = false;
          });
      });
    }

    syncProduct();
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-ssp-product]')).forEach(function (root) {
      initProduct(root);
      initAccordions(root);
    });
  });
})();
